<template>
  <div class="header__search--div">
    <div class="header__content">
      <a-input-search
        class="header__input"
        placeholder="请输入关键词或者产品名称"
        enter-button="搜索"
        size="large"
        @search="onSearch"
      />
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {

    }
  },
  methods:{
    onSearch(){}
  }
}
</script>
<style lang="less" scoped>
@import '../index.less';
</style>